type FormatPhoneOptions = {
  includeCountryCode?: boolean
}

/**
 * formatPhone - Accepts phone numbers like
 * +12223334444, 12223334444, 2223334444, (222) 333-4444, 222-333-4444 +1 222 333 4444
 * and returns normalized values - (222) 333-4444 or +1 (222) 333-4444
 * or returns original string if unable to match
 * @param {string} phoneNumber
 * @param {FormatPhoneOptions} options - Optional settings
 * @param {boolean} options.includeCountryCode - If true, prepends +1 to the formatted number
 */
export const formatPhone = (phoneNumber: string = '', options?: FormatPhoneOptions): string => {
  let cleaned = phoneNumber || '' // default to '' if null
  if (cleaned.slice(0, 2) === '+1') {
    cleaned = cleaned.slice(2)
  }
  cleaned = ('' + cleaned).replace(/\D/g, '')
  const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const formatted = '(' + match[1] + ') ' + match[2] + '-' + match[3]
    return options?.includeCountryCode ? '+1 ' + formatted : formatted
  }
  return phoneNumber || ''
}
